export default "__VITE_ASSET__DRWt0_98__"